import {BaseApi} from "./BaseApi";
import ICustomer from "./models/ICustomer";


export class ProjectApi extends BaseApi {

    public getCustomer(searchTerm: string): Promise<ICustomer[]> {
        const encoded = encodeURIComponent(searchTerm);
        return this.requestGet(`/dccockpit/customers?searchterm=${encoded}`);
    }

    public createCustomer(customer: any): Promise<ICustomer[]> {
      return this.requestPost('/dccockpit/customers', customer);
    }


    getAvailableHousesForUser() {
      return this.requestGet('/dccockpit/customers/gchouses');
    }

    getAvailableKeyAcccounts() {
      return this.requestGet('/dccockpit/customers/keyaccounts');
    }

    getCustomerProducts(projectId: string) {
      return this.requestGet('/dccockpit/customers/products/'+projectId);
    }

    getAvailableUsers() {
      return this.requestGet('/dccockpit/customers/users');
    }

    checkCustomer(customerID: string) {
      return this.requestGet('/dccockpit/customers/check/'+customerID);
    }

    updateCustomer(customer: any) {
      return this.requestPut('/dccockpit/customers/'+customer.Id, customer);
    }

    getContactPositions() {
      return this.requestGet('/dccockpit/customers/contacts/positions');
    }

    createContact(companyId: string, contact: any) {
      return this.requestPost('/dccockpit/customers/'+companyId+'/contacts', contact);
    }

    updateContact(companyId: string, contactId: string, contact: any) {
      return this.requestPut('/dccockpit/customers/'+companyId+'/contacts/'+contactId, contact);
    }
}

export default new ProjectApi();
